import React, { useCallback } from 'react';
import i18n from '../../../i18n';
import useScrollPosition from '@react-hook/window-scroll';

import { makeStyles } from '@material-ui/core/styles';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';

import { FooterInternalPages } from 'components/Footer/FooterInternalPages';
import { Icon } from 'components/Icon/Icon';
import { HeaderBurger } from 'components/Header/HeaderBurger';
import { Text, TextTypography } from 'components/Text/Text';

import SellersFone from 'assets/images/sellersFone.png';
import { ReactComponent as FacebookIcon } from 'assets/icons/social/facebook--24-1.svg';
import { ReactComponent as Twitter } from 'assets/icons/social/twitter--24.svg';
import { ReactComponent as Vkontakte } from 'assets/icons/social/vk--24.svg';

import { RoutePath } from 'RoutePath';
import { subscriptionPrice } from '../../core/utils/utils';

const useStyles = makeStyles(theme => ({
    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    headerContainer: {
        position: 'fixed',
        width: '100%',
        top: 0,
        left: 0,
        zIndex: 1,
        backgroundColor: props => (props.scrollY > 375 ? '#FBFEF9' : null),
    },
    footerContainer: {
        width: '100%',
        margin: '0 auto',
    },
    bodyContainer: {
        maxWidth: 640,
        display: 'flex',
        flexDirection: 'column',
        margin: theme.spacing(13, 'auto', 3, 'auto'),
        [theme.breakpoints.down(769)]: {
            margin: theme.spacing(13, 8, 3, 8),
        },
        [theme.breakpoints.down(641)]: {
            margin: theme.spacing(12, 3, 1, 3),
        },
        [theme.breakpoints.down(321)]: {
            margin: theme.spacing(12, 2, 1, 2),
        },
    },
    homeBlog: {
        margin: theme.spacing(10, 0),
    },
    image: {
        borderRadius: theme.spacing(1),
    },
    cardContent: {
        padding: theme.spacing(4, 0, 0, 0),
    },
    title: {
        letterSpacing: -1,
    },
    subTitle: {
        marginBottom: theme.spacing(6),
        [theme.breakpoints.down(321)]: {
            marginBottom: theme.spacing(3),
        },
    },
    text: {
        marginBottom: theme.spacing(4),
        [theme.breakpoints.down(321)]: {
            marginBottom: theme.spacing(3),
        },
    },
    cardInfo: {
        display: 'flex',
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(6),
        [theme.breakpoints.down(321)]: {
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(5),
        },
    },
    socials: {
        minWidth: 104,
        display: 'flex',
        justifyContent: 'space-between',
        marginLeft: theme.spacing(2),
    },
    block: {
        width: '100%',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
    },
    lists: {
        margin: 0,
        paddingLeft: 20,
    },
    bold: {
        fontWeight: 'bold',
    },
}));

export const BlogPage = () => {
    const scrollY = useScrollPosition(60 /*fps*/);
    const classes = useStyles({ scrollY });
    const { t } = i18n.useTranslation();

    const handleSetMapClick = useCallback(() => {
        window.location.assign(RoutePath.FEED);
    }, []);

    const Share = {
        me: function (el: any) {
            Share.popup(el.href);
            return false;
        },

        popup: function (url: any) {
            window.open(url, '', 'toolbar=0,status=0,width=626,height=436');
        },
    };

    return (
        <div className={classes.mainContainer}>
            <div className={classes.headerContainer}>
                <HeaderBurger />
            </div>
            <div className={classes.bodyContainer}>
                <div>
                    <div>
                        <CardMedia
                            component="img"
                            alt={t('blogs:blog1.photoGirlWithTablet')}
                            height="50%"
                            image={SellersFone}
                            title={t('blogs:blog1.title')}
                            className={classes.image}
                        />
                        <CardContent className={classes.cardContent}>
                            <Text typography={TextTypography.TITLE_STRONG_CHANGE} className={classes.title}>
                                {t('blogs:blog1.title')}
                            </Text>
                            <div className={classes.cardInfo}>
                                <Text typography={TextTypography.BODY_LIGHT}>{t('blogs:blog1.data')}</Text>
                                <div className={classes.socials}>
                                    <a
                                        href="https://vk.com/share.php?url=https://any.market/kak-sozdat-internet-magazin-besplatno-na-any-market&title=Как создать интернет-магазин бесплатно?"
                                        target="_blank"
                                        itemProp="url"
                                        rel="noopener noreferrer"
                                    >
                                        <div>
                                            <Icon component={Vkontakte} />
                                        </div>
                                    </a>
                                    <a
                                        href="https://twitter.com/intent/tweet?original_referer=http%3A%2F%2Ffiddle.jshell.net%2F_display%2F&text=Как создать интернет-магазин бесплатно?&url=https://any.market/kak-sozdat-internet-magazin-besplatno-na-any-market"
                                        target="_blank"
                                        itemProp="url"
                                        rel="noopener noreferrer"
                                    >
                                        <div>
                                            <Icon component={Twitter} />
                                        </div>
                                    </a>
                                    <a
                                        href="https://www.facebook.com/sharer.php?src=sp&amp;u=https://any.market/kak-sozdat-internet-magazin-besplatno-na-any-market&title=Как создать интернет-магазин бесплатно?"
                                        target="_blank"
                                        itemProp="url"
                                        rel="noopener noreferrer"
                                    >
                                        <div>
                                            <Icon component={FacebookIcon} />
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div className={classes.block}>
                                <div className={classes.subTitle}>
                                    <Text typography={TextTypography.DISPLAY_STRONG_CHANGE} className={classes.title}>
                                        {t('blogs:blog1.block1.title')}
                                    </Text>
                                </div>
                                <div className={classes.text}>
                                    <Text typography={TextTypography.LEAD_LIGHT} className={classes.title}>
                                        {t('blogs:blog1.block1.text1.1')}
                                        <span className={classes.bold}>{t('blogs:blog1.block1.text1.2')}</span>
                                    </Text>
                                </div>
                                <div className={classes.text}>
                                    <Text typography={TextTypography.LEAD_LIGHT} className={classes.title}>
                                        {t('blogs:blog1.block1.text2')}
                                    </Text>
                                </div>
                                <div className={classes.text}>
                                    <ol className={classes.lists}>
                                        <li>
                                            <Text typography={TextTypography.LEAD_LIGHT} className={classes.title}>
                                                {t('blogs:blog1.block1.text3.1')}
                                            </Text>
                                        </li>
                                        <li>
                                            <Text typography={TextTypography.LEAD_LIGHT} className={classes.title}>
                                                {t('blogs:blog1.block1.text3.2', { price: subscriptionPrice() })}
                                            </Text>
                                        </li>
                                        <li>
                                            <Text typography={TextTypography.LEAD_LIGHT} className={classes.title}>
                                                {t('blogs:blog1.block1.text3.3')}
                                            </Text>
                                        </li>
                                        <li>
                                            <Text typography={TextTypography.LEAD_LIGHT} className={classes.title}>
                                                {t('blogs:blog1.block1.text3.4')}
                                            </Text>
                                        </li>
                                    </ol>
                                </div>
                                <div className={classes.text}>
                                    <Text typography={TextTypography.LEAD_LIGHT} className={classes.title}>
                                        {t('blogs:blog1.block1.text4')}
                                    </Text>
                                </div>
                                <div className={classes.text}>
                                    <Text typography={TextTypography.LEAD_LIGHT} className={classes.title}>
                                        {t('blogs:blog1.block1.text5')}
                                    </Text>
                                </div>
                                <div className={classes.text}>
                                    <Text typography={TextTypography.LEAD_LIGHT} className={classes.title}>
                                        {t('blogs:blog1.block1.text6')}
                                    </Text>
                                </div>
                                <div className={classes.text}>
                                    <Text typography={TextTypography.LEAD_LIGHT} className={classes.title}>
                                        {t('blogs:blog1.block1.text7')}
                                    </Text>
                                </div>
                            </div>
                            <div className={classes.block}>
                                <div className={classes.subTitle}>
                                    <Text typography={TextTypography.DISPLAY_STRONG_CHANGE} className={classes.title}>
                                        {t('blogs:blog1.block2.title')}
                                    </Text>
                                </div>
                                <div className={classes.text}>
                                    <Text typography={TextTypography.LEAD_LIGHT} className={classes.title}>
                                        {t('blogs:blog1.block2.text1')}
                                    </Text>
                                </div>
                                <div className={classes.text}>
                                    <Text typography={TextTypography.LEAD_STRONG} className={classes.title}>
                                        {t('blogs:blog1.block2.text2')}
                                    </Text>
                                </div>
                                <div className={classes.text}>
                                    <ul className={classes.lists}>
                                        <li>
                                            <Text typography={TextTypography.LEAD_LIGHT} className={classes.title}>
                                                {t('blogs:blog1.block2.text3.1')}
                                            </Text>
                                        </li>
                                        <li>
                                            <Text typography={TextTypography.LEAD_LIGHT} className={classes.title}>
                                                {t('blogs:blog1.block2.text3.2')}
                                            </Text>
                                        </li>
                                        <li>
                                            <Text typography={TextTypography.LEAD_LIGHT} className={classes.title}>
                                                {t('blogs:blog1.block2.text3.3')}
                                            </Text>
                                        </li>
                                        <li>
                                            <Text typography={TextTypography.LEAD_LIGHT} className={classes.title}>
                                                {t('blogs:blog1.block2.text3.4')}
                                            </Text>
                                        </li>
                                        <li>
                                            <Text typography={TextTypography.LEAD_LIGHT} className={classes.title}>
                                                {t('blogs:blog1.block2.text3.5')}
                                            </Text>
                                        </li>
                                    </ul>
                                </div>
                                <div className={classes.text}>
                                    <Text typography={TextTypography.LEAD_STRONG} className={classes.title}>
                                        {t('blogs:blog1.block2.text4')}
                                    </Text>
                                </div>
                                <div className={classes.text}>
                                    <ul className={classes.lists}>
                                        <li>
                                            <Text typography={TextTypography.LEAD_LIGHT} className={classes.title}>
                                                {t('blogs:blog1.block2.text5.1')}
                                            </Text>
                                        </li>
                                        <li>
                                            <Text typography={TextTypography.LEAD_LIGHT} className={classes.title}>
                                                {t('blogs:blog1.block2.text5.2')}
                                            </Text>
                                        </li>
                                        <li>
                                            <Text typography={TextTypography.LEAD_LIGHT} className={classes.title}>
                                                {t('blogs:blog1.block2.text5.3')}
                                            </Text>
                                        </li>
                                    </ul>
                                </div>
                                <div className={classes.text}>
                                    <Text typography={TextTypography.LEAD_LIGHT} className={classes.title}>
                                        {t('blogs:blog1.block2.text6')}
                                    </Text>
                                </div>
                                <div className={classes.text}>
                                    <Text typography={TextTypography.LEAD_LIGHT} className={classes.title}>
                                        {t('blogs:blog1.block2.text7.1')}
                                        <span className={classes.bold}>{t('blogs:blog1.block2.text7.2')}</span>
                                        {t('blogs:blog1.block2.text7.3')}
                                        <span className={classes.bold}>{t('blogs:blog1.block2.text7.4')}</span>
                                        {t('blogs:blog1.block2.text7.5')}
                                        <span className={classes.bold}>{t('blogs:blog1.block2.text7.6')}</span>
                                        {t('blogs:blog1.block2.text7.7')}
                                        <span className={classes.bold}>{t('blogs:blog1.block2.text7.8')}</span>
                                        {t('blogs:blog1.block2.text7.9')}
                                        <span className={classes.bold}>{t('blogs:blog1.block2.text7.10')}</span>
                                        {t('blogs:blog1.block2.text7.11')}
                                    </Text>
                                </div>
                            </div>
                            <div className={classes.block}>
                                <div className={classes.subTitle}>
                                    <Text typography={TextTypography.LEAD_STRONG} className={classes.title}>
                                        {t('blogs:blog1.block3.title')}
                                    </Text>
                                </div>
                            </div>
                        </CardContent>
                    </div>
                </div>
            </div>

            <div className={classes.footerContainer}>
                <FooterInternalPages />
            </div>
        </div>
    );
};
